export default "__VITE_ASSET__C127tlS3__"